// Keep in sync with InstrumentTag::MAX_NAME_LENGTH
export const INSTRUMENT_TAG_MAX_NAME_LENGTH = 30
